<template>
  <div class="submit-button">
    <button 
    class="btn tla-btn tla-btn--info" 
    @click="submitForm()" 
    :disabled="isDisabled" 
    type="button"
    name="submit-button" 
    id="submit-button">
      {{ currentButtonText }}
    </button>
    <p v-if="submitFailed" class="submit-button__text text-danger">Something went wrong, please try again or call us on
      0844 445 7863.</p>
    <p v-if="submitSuccess" class="submit-button__text">Thanks! We'll shortly email you with confirmation of the next
      steps.</p>
    <div v-if="!submitSuccess" class="submit-button__text">
      <small v-html="smallPrint"></small>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Inject
} from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import FormSubmissionState from '@/enums/FormSubmissionState';
import Policy from '@/models/Policy';
import { enquiryService } from '../../services/EnquiryService';
import { enquiryBuilderService } from '../../services/EnquiryBuilderService';

@Component
export default class SubmitButtonComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'Submit' })
  public buttonText!: string;

  @Prop({ default: null })
  public validationScope!: string;

  public get currentStep(): number {
    return this.$store.getters['enquiryModule/currentStep'];
  }

  public get enquirySubmissionState(): number {
    return this.$store.getters['enquiryModule/enquirySubmissionState'];
  }

  public get servicePolicy(): Policy {
    return this.$store.getters['policyModule/servicePolicy'];
  }

  public setFormSubmissionState(formState: FormSubmissionState) {
    this.$store.dispatch('enquiryModule/submitFormSubmissionState', formState);
  }

  // Component

  public async submitForm() {
    this.setFormSubmissionState(FormSubmissionState.Submitting);

    await this.$store.dispatch('enquiryModule/submitReCaptchaToken');

    enquiryService
      .submitEnquiry(enquiryBuilderService.buildEnquiry())
      .catch((result) => {
        this.setFormSubmissionState(
          FormSubmissionState.SubmissionFailed
        );
      });
  }

  public get smallPrint() {
    return this.servicePolicy.policySummary;
  }

  public get submitFailed(): boolean {
    return (
      this.enquirySubmissionState
      === FormSubmissionState.SubmissionFailed
    );
  }

  public get isSubmitting(): boolean {
    return (
      this.enquirySubmissionState
      === FormSubmissionState.Submitting
    );
  }

  public get submitSuccess(): boolean {
    return (
      this.enquirySubmissionState
      === FormSubmissionState.SubmissionSuccess
    );
  }

  public get invalid() {
    return this.$validator.errors.items.filter((x) => x.scope === this.validationScope).length > 0;
  }

  public get isDisabled() {
    if (this.invalid) {
      return true;
    }

    return this.isSubmitting || this.submitSuccess;
  }

  public get currentButtonText() {
    if (this.isSubmitting) {
      return 'Submitting...';
    } if (this.submitSuccess) {
      return 'Submitted';
    }

    return this.buttonText;
  }
}
</script>
